export default {
  ru: {
    title: 'Развлечения',
    dance: 'Станцуй',
    song: 'Спой песню',
    joke: 'Расскажи шутку',
    photo: 'Сделай фото',
    cancel: 'Назад',
  },
  en: {
    // en
  },
};
